import { render } from "./zmyzAbout.vue?vue&type=template&id=56283a10&scoped=true"
import script from "./zmyzAbout.vue?vue&type=script&lang=js"
export * from "./zmyzAbout.vue?vue&type=script&lang=js"

import "./zmyzAbout.vue?vue&type=style&index=0&id=56283a10&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56283a10"]])

export default __exports__